module.exports = __webpack_public_path__ + "static/media/login_image_2.4fa1a0b6.svg";